import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import apiClient from "../api/apiClient";
import { TextField, Button, Typography, Box, Container } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import logo from '../assets/images/loginleft.jpg';
import './Login.css';

const Login = ({ onLogin }) => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [message, setMessage] = useState("");
    const { login } = useAuth();
    const navigate = useNavigate();
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        await apiClient.post("/auth/login", formData)
        .then(response => {
          localStorage.setItem("token", response.data.token);
          login(response.data.token);
          setMessage("Login successful");
          setTimeout(() => navigate("/home"), 1000); // รอ 1 วินาทีแล้วนำทาง
        })
        .catch(error => {
          setMessage(error.response?.data?.error || "Login failed" || error);
        });
    };

    return (
        <div className="login-container">
            {/* Left side: Image */}
            <div className="login-image">
                <img src={logo} alt="Financial Analytics Platform" />
            </div>

            {/* Right side: Login Form */}
            <div className="login-form">
                <Container component="main" maxWidth="85%" disableGutters sx={{ width: '100%' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '85%', // ขยายเต็ม Container
                            maxWidth: '85%', // ป้องกันล้นออกข้าง
                            maxHeight: '85%',
                            height: '85%',
                            padding: 3,
                            borderRadius: 2,
                            boxShadow: 3,
                            backgroundColor: 'background.paper',
                        }}
                    >
                        <Typography 
                            variant="h5" 
                            gutterBottom 
                            sx={{ fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' } }}
                        >
                            เข้าสู่ระบบ
                        </Typography>

                        <form onSubmit={handleLogin} style={{ width: '100%' }}>
                            <TextField
                                fullWidth
                                label="Email"
                                name="email"
                                value={formData.email} // แก้ไขชื่อเป็น formData.email
                                onChange={handleChange}
                                margin="normal"
                                required
                                type="email"
                                sx={{
                                fontSize: { xs: '1rem', sm: '1rem', md: '1rem' }, 
                                '& .MuiInputBase-input': { fontSize: { xs: '1rem', sm: '1rem', md: '1rem' } }
                                }}
                            />

                            <TextField
                                fullWidth
                                label="Password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                margin="normal"
                                required
                                type="password"
                                sx={{
                                fontSize: { xs: '1rem', sm: '1rem', md: '1rem' }, 
                                '& .MuiInputBase-input': { fontSize: { xs: '1rem', sm: '1rem', md: '1rem' } }
                                }}
                            />

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{
                                mt: 3, 
                                mb: 2, 
                                fontSize: { xs: '1rem', sm: '1rem', md: '1rem' },
                                padding: { xs: '8px', sm: '8px', md: '8px' }
                                }}
                            >
                                Login
                            </Button>
                        </form>
                        {message && <Typography color="error" align="center" mt={2}>{message}</Typography>}
                        <Typography variant="body2" color="text.secondary">
                            เข้าใช้งานระบบติดต่อ{' '}
                            <Link to="https://www.aiscimer.com/">aiscimer</Link>
                        </Typography>
                    </Box>
                </Container>
            </div>
        </div>
    );
};

export default Login;
